import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import PageMeta from '../components/PageMeta';
import { BUSINESS } from '../data/business';

const values = [
  { icon: 'pi-shield', text: 'Ich verkaufe keine Produkte – nur ehrliche Beratung.' },
  { icon: 'pi-comment', text: 'Ohne Fachchinesisch. Technik kann man einfach erklären.' },
  { icon: 'pi-heart', text: 'Transparent, fair und mit gesundem Menschenverstand.' },
];

const stats = [
  { num: '20+', label: 'Jahre Technik-Erfahrung' },
  { num: '100%', label: 'Unabhängige Beratung' },
];

const AboutPage = () => {
  const [showImg2, setShowImg2] = useState(false);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Alexander Krein',
    jobTitle: 'Staatlich geprüfter Techniker für Informations- und Kommunikationstechnik',
    description: 'Unabhängige IT-Beratung für Privatpersonen – SmartHome, Netzwerk, WLAN, Hardware und 3D-Druck.',
    url: `${BUSINESS.url}/ueber-mich`,
    image: `${BUSINESS.url}/assets/me_1.jpg`,
    email: BUSINESS.email,
    telephone: BUSINESS.telephone,
    address: BUSINESS.address,
    worksFor: {
      '@type': 'LocalBusiness',
      name: BUSINESS.name,
      url: BUSINESS.url,
    },
  };

  return (
    <>
    <PageMeta
      title="Über mich – Alexander Krein"
      description="Staatlich geprüfter Techniker für Informations- und Kommunikationstechnik. Unabhängige IT-Beratung für Privatpersonen – ehrlich, verständlich, vor Ort."
      path="/ueber-mich"
    />
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
    <section className="mx-auto max-w-[1024px] px-8 py-[clamp(40px,7vw,72px)]">
      <div className="flex flex-row flex-wrap items-start gap-12">

        {/* Text */}
        <div className="min-w-0 flex-1 basis-[340px]">
          <h1 className="mb-6 text-[clamp(1.75rem,3vw,2.5rem)] font-bold leading-[1.2] text-white">
            Hi, ich bin Alexander –<br />
            <span className="text-ak-sky">Ihr Technik-Erklärer.</span>
          </h1>

          <div className="flex flex-col gap-3.5">
            <p className="m-0 text-[15px] leading-[1.7] text-white/80">
              Staatlich geprüfter Techniker für Informations- und Kommunikationstechnik, leidenschaftlicher Tüftler
              und Familienmensch mit einem ausgeprägten Hang zu funktionierender Technik.
            </p>
            <p className="m-0 text-[15px] leading-[1.7] text-white/80">
              Ich lebe mit meiner Frau, unserer kleinen Tochter, Hund Buddy (ein quirliger Australien Shepherd–Labrador-Mix)
              und Katze Groot (der wahre Chef im Haus) in einem längst smart vernetzten Zuhause.
            </p>
            <p className="m-0 text-[15px] leading-[1.7] text-white/80">
              Meine Begeisterung für Technik begleitet mich seit über 20 Jahren. Was mich zur Selbstständigkeit gebracht hat?
              Ich sehe, wie oft Menschen von Technik überfordert sind – nicht weil sie unfähig sind, sondern weil niemand
              ehrlich und verständlich erklärt, was wirklich gebraucht wird.
              <strong className="text-white"> Genau das möchte ich ändern.</strong>
            </p>
          </div>

          {/* Was mir wichtig ist */}
          <div className="mt-8 flex flex-col gap-3.5">
            <h2 className="mb-1 text-base font-bold text-white">Was mir wichtig ist</h2>
            {values.map((v, i) => (
              <div key={i} className="flex items-center gap-3.5 rounded-[14px] border border-white/5 bg-ak-dark/50 px-4 py-3.5">
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] bg-ak-sky/[0.09]">
                  <i className={`pi ${v.icon} text-[15px] text-ak-sky`}></i>
                </div>
                <p className="m-0 text-sm leading-[1.6] text-white/80">{v.text}</p>
              </div>
            ))}
          </div>

          <p className="mt-7 text-[15px] font-semibold italic text-white">
            &quot;Wenn Sie jemanden suchen, der Technik mit Herz und Verstand angeht – ich bin da.&quot;
          </p>
        </div>

        {/* Foto */}
        <div className="flex w-full flex-col items-center gap-3 sm:w-[260px] sm:flex-none">
          <div className="w-full rounded-[20px] border border-ak-sky/15 bg-ak-dark p-4 shadow-[0_20px_40px_rgba(0,0,0,0.3)]">
            <img
              src={showImg2 ? '/assets/me_2.webp' : '/assets/me_1.webp'}
              alt="Alexander Krein"
              width={520}
              height={550}
              loading="lazy"
              onClick={() => setShowImg2((v) => !v)}
              className="block h-auto w-full cursor-pointer rounded-xl transition-opacity duration-300"
              title="Klicken zum Wechseln"
            />
          </div>
          <p className="m-0 text-center text-xs text-ak-dim">
            <i className="pi pi-refresh mr-[5px]"></i>Klicken zum Bild wechseln
          </p>

          {/* Stat Cards */}
          <div className="mt-2 flex w-full flex-col gap-2">
            {stats.map((stat, i) => (
              <div key={i} className="flex items-center gap-3 rounded-xl border border-ak-sky/[0.12] bg-ak-dark/60 px-4 py-3">
                <span className="text-[22px] font-bold text-ak-sky">{stat.num}</span>
                <span className="text-xs leading-[1.4] text-ak-muted">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default AboutPage;
